import React from "react";
import { Card, Col, Stack } from "react-bootstrap";
import hlogo from "../images/hlogo.jpg";
function PasswordEmailSent() {
  return (
    <div className="rolecontainer d-flex justify-content-center align-items-center my-auto">
      <Card>
        <Card.Body className="p-4">
          <Stack
            className=" d-flex justify-content-center align-items-center"
            gap={3}>
            <img src={hlogo} alt="homeworkhost_logo" id="logo" />
            <h6 style={{ color: "#2a357e" }}>
              A Password Reset link has been sent to your Email Address
            </h6>
          </Stack>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PasswordEmailSent;
